import React, { Component, useState } from "react";
import { Link } from "react-router-dom";
import "../../Styles/globalStyle.css";
import useValidationInput from "../../../Hooks/useValidationInput.js";
import useAxiosOperation from "../../../Hooks/useAxiosOperation.js";
import SpinnerIcon from "../../Commands/SpinnerIcon/SpinnerIcon.js";
import useLogIcon from "../../../Hooks/useLogIcon.js";
import CheckBox from "../../Commands/CheckBox/CheckBox";
import uuid from "react-native-uuid";

export default function Demo(props) {
  const isInputValid = useValidationInput();
  const axiosOperation = useAxiosOperation();
  const getLogIcon = useLogIcon();
  const  [user, setUser] = useState({ 
    id: uuid.v4(),
    firstName : "",
    lastName : "",
    comment : "",
    email : "",
    errors:[],
    loading:false
 })

  const fireEventKeyPress = (e, detail, typeValidations) => {
     
    var userData = JSON.parse(JSON.stringify(user));
  
    userData.errors = userData.errors.filter(error => error.id != detail.id )

    if(typeValidations,  !isInputValid({value: e.key}, typeValidations).isValid) {
      e.preventDefault()
    }
    setUser(userData);
  }

  const validInput = (value, detail, typeValidation, userData) => {
    const eventResponse = isInputValid({value: value}, typeValidation);
    if(eventResponse.isValid) {
      userData.errors = userData.errors.filter(error => error.id != detail.id )
    }
    else {
      userData.errors.push({id:detail.id
        , text: eventResponse.type == "EMAIL" ? "The email is invalid" : "The field is required".replace("field", detail.name)})
    }
  }

  const fireOtherEvent = (e, detail, typeValidation) => {
  
    var userData = JSON.parse(JSON.stringify(user));
    //const eventResponse = isInputValid({value: e.target.value}, typeValidation);
    
    validInput(e.target.value, detail, typeValidation, userData) 
    setUser(userData);
  }

  const onCreate = () => {
    /*
    var userData = JSON.parse(JSON.stringify(user));
    

    validInput(user.firstName, {id:"FirstName", name:"First Name" }, [{type :"REQUIRE"}], userData) 
    validInput(user.lastName, {id:"LastName", name:"Last Name" }, [{type :"REQUIRE"}], userData) 
    validInput(user.email, {id:"Email", name:"Email" }, [{type :"REQUIRE"}], userData) 
    
    userData.email = userData.email.toLocaleLowerCase()
    
    if (userData.errors.length == 0) {
      axiosOperation({method:"POST"
        , url: "https://flex-services.onrender.com/user/"
        , body:userData
        }).then(response => 
          { 
            if(response.managedError) {
              const result = response.result.data
              setUser({...userData, log:{type:result.log.type, text:result.log.text, style:result.log.style, activeResendEmail:result.activeReSendEmail}})
            }
            else {
              setUser({...userData, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}})
            }
          })
      
    }
    else 
      setUser(userData);
      */
  }

  const getError = (id) => {
    const error =  user.errors.filter(item => item.id == id)[0]
    return <div style={{border:"none", backgroundColor:"transparent", userSelect:"none",
     paddingTop:"0px", marginTop:"0px", height:"15px",  color: "rgb(206, 17, 38)", fontSize: 10}} 
     >{error ? error.text: ""}</div>
    
  };
  const isNewRegister = !(user.log && user.log.activeResendEmail) 

  const canClick = user.errors.length == 0  && !user.loading
  
  return (
    <div style = {{ margin:"auto", width:"250px", marginTop: "50px", padding: "20px", backgroundColor:"white"  }}>
      <div style = {{ display:"flex"  }}>
        <span style = {{ fontFamily:"Verdana",fontSize:"16px"  }} >Request a demo</span>
        <div style = {{ marginLeft:"10px"  }}>
        { user.loading ? <SpinnerIcon /> : (user.log ? getLogIcon(user.log.type) : null)}
        </div>
      </div>
      <div style = {{ marginBottom:"5px"  }}>
        { user.log && <span style = {user.log.style} >{user.log.text}</span>}
      </div>
      {<input id="FirstName" type="textBox" placeholder="First Name" value={user.firstName}  
          onChange={(e)=> setUser({...user, firstName:e.target.value})}
          onBlur={(e) => fireOtherEvent(e, {id:"FirstName", name:"First Name" }, [{type :"REQUIRE"}])}
          onKeyPress={(e) => fireEventKeyPress(e, {id:"FirstName" })}
          style = {{marginTop:"10px"  }}
          className="input connexionInput" />}
      {isNewRegister && getError("FirstName")}

      {<input id="LastName" type="textBox" placeholder="Last Name" value={user.lastName}  
          onChange={(e)=> setUser({...user, lastName:e.target.value})}
          onBlur={(e) => fireOtherEvent(e, {id:"LastName", name:"Last Name" }, [{type :"REQUIRE"}])}
          onKeyPress={(e) => fireEventKeyPress(e, {id:"LastName" })}
          className="input connexionInput" />}
      {isNewRegister && getError("LastName")}

      {<input id="Email" type="textBox" placeholder="Email" value={user.email} 
        readOnly={user.log && user.log.activeResendEmail} 
        onChange={(e)=> setUser({...user, email:e.target.value})}
        onBlur={(e) => fireOtherEvent(e, {id:"Email", name:"Email" }, [{type :"REQUIRE"}, {type :"EMAIL"}])}
        onKeyPress={(e) => fireEventKeyPress(e, {id:"Email" })}
        className="input connexionInput" />}
      {isNewRegister && getError("Email")}

      {<textarea id="Comment" type="textBox" placeholder="Comment" value={user.email} 
        style = {{height:"100px", resize:"none" }}
        readOnly={user.log && user.log.activeResendEmail} 
        onChange={(e)=> setUser({...user, comment:e.target.value})}
        onKeyPress={(e) => fireEventKeyPress(e, {id:"Comment" })}
        className="input connexionInput" />}
      {isNewRegister && getError("Comment")}
      
           
      <div style = {{ textAlign:"center", display:"flex" }}>
        <input disabled={!canClick} 
          type="button" className="button" 
          style = {{ height:"30px", width: "250px"
          , marginTop:"10px" }} 
          value={"Send request" }
          onClick = {(e) => onCreate(e)} 
        />
      </div>  
    </div>
  );
};

/*

<div style = {{ textAlign:"center", display:"flex" }}>
        <Link  style = {{ fontFamily:"Verdana", marginRight:"auto", textDecoration: "none"  }}to="/register">
          <span style = {{ fontSize:"12px", color:"#008dff"}} >Forget password?</span>
        </Link>
        <Link style = {{ fontFamily:"Verdana", marginLeft:"auto", textDecoration: "none"  }} to="/register">
          <span style = {{ fontSize:"12px", color:"yellowGreen" }} >Sign In</span>
        </Link>
      </div>
  */


